import React from "react";
import { useParams, Link } from "react-router-dom";
import services from "../data/services";

function ServiceDetail() {
  const { id } = useParams();
  const service = services.find((s) => String(s.id) === id);

  if (!service) {
    return (
      <div className="container text-center my-5">
        <h2>Service Not Found</h2>
        <Link to="/services" className="theme-btn-1">
          Back to Services
        </Link>
      </div>
    );
  }

  return (

     <>
     <section className="inner-banner-sec">
                <div className="container-fluid add-padding-2">
                    <div className="inner-bg-img">
                        <div className="row">
                            <div className="col-lg-12 col-md-12 col-sm-12 col-12 align-self-center">
                                <div className="banner_text">
                                    <h1>
                                        <span>Services</span>
                                    </h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

      <section className="service-detail-sec">
      <div className="container-fluid add-padding">
        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div className="service-detail-box">
              <img src={service.img} alt={service.title} />
              <h2>{service.title}</h2>
              <p>{service.longDesc || service.desc}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
     </>

    
  );
}

export default ServiceDetail;
